import { FC, Fragment, useMemo } from "react";
import SourceDataItemValue, { ISourceDataItemValueProps } from "./SourceDataItemValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppSettings } from "@/AppSettings";
import { Box, IconButton, Table, TableBody, TableCell, TableHead, TableRow, styled, tooltipClasses } from "@mui/material";
import useItemValueConfigurations from "@/hooks/form/configuration/useItemValueConfigurations";
import { StatusListNoteTable, StatusListNoteTooltip } from "@/components/lists/status/StatusListStats";
// import { fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9 } from "@fortawesome/pro-duotone-svg-icons";
// import { IconProp } from "@fortawesome/fontawesome-svg-core";

// const NumberMap: Record<string, IconProp> = {
//     "0": fa0,
//     "1": fa1,
//     "2": fa2,
//     "3": fa3,
//     "4": fa4,
//     "5": fa5,
//     "6": fa6,
//     "7": fa7,
//     "8": fa8,
//     "9": fa9
// }

const Tooltip = styled(StatusListNoteTooltip)(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        minWidth: 300,
    }
}))

const TooltipTable = styled(StatusListNoteTable)(({ theme }) => ({
    '& td': {
        padding: theme.spacing(1),
        textAlign: 'left',
        whiteSpace: 'nowrap',
        '&:first-of-type': {
            width: 80
        }
    }
}))

const SourceDataItemMultiLookupValue: FC<ISourceDataItemValueProps> = ({
    itemData,
    hideBorderStyles,
    hideStyles
}) => {
    
    // const icons = useMemo(() => {
    //     if (!itemData?.sourceDataItem?.value) {
    //         return undefined;
    //     }

    //     return itemData.sourceDataItem.value.split('').map((x, i) => {
    //         const icon = NumberMap[x];

    //         if (!icon) {
    //             return null;
    //         }

    //         return <FontAwesomeIcon key={i} icon={icon} />
    //     })
    // }, [itemData?.sourceDataItem?.value])


    const tooltipInfo = useMemo(() => {
        return (
            <Tooltip 
                placement="bottom-end"
                title={
                    <>
                        <strong>Potential Values</strong>
                        <TooltipTable>
                            <thead>
                                <tr>
                                    <td>
                                        Value
                                    </td>
                                    <td>
                                        Label
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemData?.itemValueConfigurations?.map((x, i) => (
                                        <tr
                                            key={`${i}-${x.itemValue}`}
                                        >
                                            <td>
                                                {x.itemValue} 
                                            </td>
                                            <td>
                                                {x.displayName}
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </TooltipTable>
                    </>
                }
            >
                <FontAwesomeIcon size="lg" icon={AppSettings.icons.alertInformation} />
            </Tooltip>
        )
    }, [itemData?.itemValueConfigurations])

    const value = useMemo(() => {
        const values = itemData?.sourceDataItem?.value?.split(',');

        return values?.map((id) => {
            const valueDisplayName = itemData?.itemValueConfigurations?.find(x => x.itemValue === id.trim())?.displayName;

            return (
                <SourceDataItemValue
                    hideBorderStyles={hideBorderStyles}
                    hideStyles={hideStyles}
                    startAdornment={valueDisplayName ?? id}
                    //startAdornment={icons}
                    endAdornment={
                        tooltipInfo
                    }
                >
                    {valueDisplayName ?? id}
                </SourceDataItemValue>
            );
        }, undefined)
    }, [itemData?.sourceDataItem?.value, itemData?.itemValueConfigurations])

    return (
        <Box>
            {value}
        </Box>
    );
};

export default SourceDataItemMultiLookupValue;